import React from "react";
import { connect } from "react-redux";
import Mybag from "./Mybag";

class PdtWrap extends React.Component {
  render() {
    const {
      getMyBagSuccessfully,
      myBagData,
      deliveryOption,
      pickupOption,
      deliverOption_btn_active
    } = this.props;
    return (
      <>
        {getMyBagSuccessfully &&
          Array.isArray(myBagData.cartItems) &&
          myBagData.cartItems.map((item, i) => {
            return (
              <Mybag
                key={i}
                item={item}
                IsDeliveryMode={deliverOption_btn_active}
                addressId={deliveryOption.delivery_address_radioGrp.value}
                storeId={pickupOption.pickup_stores.value}
              />
            );
          })}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    getMyBagSuccessfully: state.myBag.getMyBagSuccessfully,
    myBagData: state.myBag.myBagData
  };
};

export default connect(mapStateToProps, null)(PdtWrap);
